import { Component } from "react";

export default class UserRegistry extends Component {
  render() {
    return null;
  }
}
